const centrifuge = new Centrifuge(window.CENTRIFUGO_CONFIG);

centrifuge.connect();

export default centrifuge;
